<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Shading</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select :items="types" label="Select Shading Type*" required v-model="selectedtype"></v-select>
              </v-col>
              <!-- Horizontal & Combination shading -->
              <v-col cols="6" v-if="selectedtype === 'Combination' || selectedtype === 'Horizontal Overhang'">
                <v-text-field label="Overhang(H)" required type="number" v-model="overhangH">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
              <v-col cols="6" v-if="selectedtype === 'Combination' || selectedtype === 'Horizontal Overhang'">
                <v-text-field label="Overhang(V)" required type="number" v-model="overhangV">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Balcony 2 side covered -->
            <v-row v-if="selectedtype === `Balcony-2side-covered`">
              <v-col cols="6">
                <v-text-field label="Balcony-depth(H)" required type="number" v-model="overhangH">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Balcony(V)" required type="number" v-model="overhangV">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Balcony 3 side Open -->
            <v-row v-if="selectedtype === `Balcony-3side-open`">
              <v-col cols="6">
                <v-text-field label="Balcony-depth(H)" required type="number" v-model="overhangH">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Balcony(V)" required type="number" v-model="overhangV">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Vertical shading -->
            <v-row v-if="selectedtype === `Vertical fin(L)` || selectedtype === `Vertical fin(R)`">
              <v-col cols="6">
                <v-text-field label="Vertical(H)" required type="number" v-model="overhangH">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Vertical(V)" required type="number" v-model="overhangV">
                  <div slot="append">mm</div>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Combination Table Inputs -->
            <!-- Left Inputs -->
            <div v-if="selectedtype === 'Combination' || selectedtype === `Balcony-2side-covered`">
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Vertical-Left(H)" required type="number" v-model="overhangLeftH">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Vertical-Left(V)" required type="number" v-model="overhangLeftV">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
              </v-row>
              <!--Right Inputs  -->
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Vertical-Right(H)" required type="number" v-model="overhangRightH">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Vertical-Right(V)" required type="number" v-model="overhangRightV">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <!-- Balcony 1 side covered  -->
            <div v-if="selectedtype === `Balcony-1side-covered`">
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Balcony-depth(H)" required type="number" v-model="overhangH">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Balcony-depth(V)" required type="number" v-model="overhangV">
                    <div slot="append">mm</div>
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- Covered & uncovered selection -->
              <v-row>
                <v-col cols="12">
                  <v-select :items="balconySides" label="Select Covered side" required v-model="selectedSide"></v-select>
                </v-col>
              </v-row>
              <!-- If left side selected -->
              <div v-if="selectedSide === 'Left Side'">
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Vertical-Left(H)" required type="number" v-model="overhangLeftH">
                      <div slot="append">mm</div>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Vertical-Left(V)" required type="number" v-model="overhangLeftV">
                      <div slot="append">mm</div>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
              <!-- If Right Side Selected -->
              <div v-if="selectedSide === 'Right Side'">
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Vertical-Right(H)" required type="number" v-model="overhangRightH">
                      <div slot="append">mm</div>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Vertical-Right(V)" required type="number" v-model="overhangRightV">
                      <div slot="append">mm</div>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>
            <br /><br />
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      Orientation
                    </th>
                    <th class="text-center">
                      Latitudes >= 23.5N
                    </th>
                    <th class="text-center">
                      Latitudes < 23.5N
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, orientation) of shgcEquiv" :key="orientation">
                    <td class="text-center">{{ orientation }}</td>
                    <td class="text-center">{{ value[0] }}</td>
                    <td class="text-center">{{ value[1] }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('close')">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveShading">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// SHGC list from store
// inputs: shading type -> Hoverhang -> Voverhang
// PHovergang = H/V
// No-shading has V=H=1mm

// combination: =BaseEff * (1-((1-RightEff)+(1-LeftEff)))

// Output:
/**
 *

shading: {
    type: '',
    Hover: '',
    Vover: '',
    EffOver: '',
    ShgcEquiv: {
        N: ['Lat1', 'Lat2'],
        E: ['Lat1', 'Lat2'],
        W: ['Lat1', 'Lat2'],
        S: ['Lat1', 'Lat2'],
        NE: ['Lat1', 'Lat2'],
        NW: ['Lat1', 'Lat2'],
        SE: ['Lat1', 'Lat2'],
        SW: ['Lat1', 'Lat2'],
    }
}

//BALCONY 1 side Covered 1-(2,3)
1. overhang(H) & overhang(v)
2. user input which side covered
3. open side with h & V as 1mm (ie no shading)
4.then same as combination

 */
import { shgcTables, PFarray, shadingTypes, orientations } from '@/constant_data/shgcTables.js';
import { uid } from '@/utils/uid';

export default {
  props: ['show', 'shading'],
  data() {
    return {
      types: shadingTypes,
      selectedtype: this.shading ? this.shading.type : '',
      overhangV: this.shading ? this.shading.overhangV : 1,
      overhangH: this.shading ? this.shading.overhangH : 1,
      overhangLeftV: this.shading ? this.shading.overhangLeftV : 1,
      overhangLeftH: this.shading ? this.shading.overhangLeftH : 1,
      overhangRightV: this.shading ? this.shading.overhangRightV : 1,
      overhangRightH: this.shading ? this.shading.overhangRightH : 1,
      balconySides: ['Left Side', 'Right Side'],
      selectedSide: ``,
      // leftPF: 0,
      // rightPF: 0,
      // basePF: 0,
    };
  },

  computed: {
    overhangPF() {
      return this.overhangH / this.overhangV;
    },
    leftPF() {
      return this.overhangLeftH / this.overhangLeftV;
    },

    rightPF() {
      return this.overhangRightH / this.overhangRightV;
    },
    shgcEquiv() {
      let tableIndex = 0;
      let leftIndex = 0;
      let rightIndex = 0;

      // for (let j = 0; j < PFarray.length; j++) {
      //   if (PFarray[j] >= this.overhangPF) {
      //     tableIndex = j;
      //     console.log('Overhang PF', this.overhangPF);
      //     console.log('Base Index', tableIndex);
      //     break;
      //   }
      // }
      if (this.overhangPF > 0 && this.overhangPF < 1) {
        for (let i = 0; i < PFarray.length; i++) {
          if (PFarray[i] >= this.overhangPF.toFixed(2)) {
            tableIndex = i;
            console.log('Overhang PF', this.overhangPF);
            console.log('Base Index', tableIndex);
            break;
          }
        }
      }

      if (this.overhangPF.toFixed(2) >= 1) {
        tableIndex = PFarray.length - 1;
        console.log('Overhang PF', this.overhangPF);
        console.log('Base Index', tableIndex);
      }

      if (this.leftPF > 0 && this.leftPF < 1) {
        console.log('leftPF', this.leftPF);
        for (let i = 0; i < PFarray.length; i++) {
          if (PFarray[i] >= this.leftPF) {
            leftIndex = i;
            console.log('Left PF', this.leftPF);

            // console.log('Left Index', leftIndex);
            break;
          }
        }
      }

      if (this.leftPF >= 1) {
        leftIndex = PFarray.length - 1;
        console.log('left Index pf>1', leftIndex, this.leftPF);
      }

      //right Table Index
      if (this.rightPF > 0 && this.rightPF < 1) {
        for (let i = 0; i < PFarray.length; i++) {
          if (PFarray[i] >= this.rightPF) {
            rightIndex = i;
            console.log('Right PF', this.rightPF);
            break;
          }
        }
      }
      if (this.rightPF >= 1) {
        rightIndex = PFarray.length - 1;
        console.log('right Index pf>1', rightIndex, this.rightPF);
      }
      let result = {};

      //Shading Type Horizontal Overhang or Balcony-3side-open
      if (this.selectedtype === 'Horizontal Overhang' || this.selectedtype === `Balcony-3side-open`) {
        //title
        (this.title = this.selectedtype + '-' + this.overhangH + `(H)` + '-' + this.overhangV + `(V)`),
          orientations.forEach(orientation => {
            result[orientation] = [shgcTables.base[orientation][0][tableIndex], shgcTables.base[orientation][1][tableIndex]];
          });
      }
      //shading type Vertical fin(L)
      if (this.selectedtype === `Vertical fin(L)`) {
        this.title = this.selectedtype + this.overhangLeftH + '(H)-' + this.overhangLeftV + '(V)';

        orientations.forEach(orientation => {
          result[orientation] = [shgcTables.left[orientation][0][tableIndex], shgcTables.left[orientation][1][tableIndex]];
        });
      }
      //shading type Vertical fin(R)
      if (this.selectedtype === `Vertical fin(R)`) {
        this.title = this.selectedtype + this.overhangRightH + '(H)-' + this.overhangRightV + '(V)';

        console.log('Vertical right');
        orientations.forEach(orientation => {
          result[orientation] = [shgcTables.right[orientation][0][tableIndex], shgcTables.right[orientation][1][tableIndex]];
        });
      }
      // shading type combination OR Balcony 2side covered
      if (this.selectedtype === `Combination` || this.selectedtype === `Balcony-2side-covered`) {
        console.log('combination');
        let baseResult = {};
        let leftResult = {};
        let rightResult = {};
        //base result
        orientations.forEach(orient => {
          baseResult[orient] = [shgcTables.base[orient][0][tableIndex], shgcTables.base[orient][1][tableIndex]];
        });
        console.log('base result', baseResult);
        //left result
        orientations.forEach(orient => {
          leftResult[orient] = [shgcTables.left[orient][0][leftIndex], shgcTables.left[orient][1][leftIndex]];
        });
        console.log('left result', leftResult);
        // right result
        orientations.forEach(orient => {
          rightResult[orient] = [shgcTables.right[orient][0][rightIndex], shgcTables.right[orient][1][rightIndex]];
        });
        console.log('right result', rightResult);
        //final result
        orientations.forEach(orient => {
          let esfRight0 = 1 - rightResult[orient][0];
          let esfLeft0 = 1 - leftResult[orient][0];
          let esfRight1 = 1 - rightResult[orient][1];
          let esfLeft1 = 1 - leftResult[orient][1];

          result[orient] = [(baseResult[orient][0] * (1 - (esfRight0 + esfLeft0))).toFixed(3), (baseResult[orient][1] * (1 - (esfRight1 + esfLeft1))).toFixed(3)];
        });
        this.title = this.selectedtype + '-Overhang-' + this.overhangH + '(H)-' + this.overhangV + '(V)' + '-Vertical(L)-' + this.overhangLeftH + '(H)-' + this.overhangLeftV + '(V)-' + 'Vertical(R)-' + this.overhangRightH + '(H)-' + this.overhangRightV + '(V)';
      }

      //Balcony-1side-covered
      if (this.selectedtype === `Balcony-1side-covered`) {
        console.log('Balcony-1side-covered');
        let baseResult = {};
        let leftResult = {};
        let rightResult = {};
        //base result
        orientations.forEach(orient => {
          baseResult[orient] = [shgcTables.base[orient][0][tableIndex], shgcTables.base[orient][1][tableIndex]];
        });
        //left side covered
        if (this.selectedSide === `Left Side`) {
          //title
          this.title = this.selectedtype + '-Left' + '-Overhang-' + this.overhangH + '(H)-' + this.overhangV + '(V)' + '-Vertical(L)-' + this.overhangLeftH + '(H)-' + this.overhangLeftV + '(V)-';

          //left result

          orientations.forEach(orient => {
            leftResult[orient] = [shgcTables.left[orient][0][leftIndex], shgcTables.left[orient][1][leftIndex]];
          });

          // right result ie NO shading
          // orientations.forEach(orient => {
          //   rightResult[orient] = [shgcTables.left[orient][0][4], shgcTables.left[orient][1][4]];
          // });
          //Final effective table
          orientations.forEach(orient => {
            result[orient] = [(baseResult[orient][0] * leftResult[orient][0]).toFixed(3), (baseResult[orient][1] * leftResult[orient][1]).toFixed(3)];
          });
        } else if (this.selectedSide === `Right Side`) {
          this.title = this.selectedtype + '-Right' + '-Overhang-' + this.overhangH + '(H)-' + this.overhangV + '(V)' + 'Vertical(R)-' + this.overhangRightH + '(H)-' + this.overhangRightV + '(V)';

          // right result
          orientations.forEach(orient => {
            rightResult[orient] = [shgcTables.right[orient][0][rightIndex], shgcTables.right[orient][1][rightIndex]];
          });
          // left result ie NO shading
          // orientations.forEach(orient => {
          //   leftResult[orient] = [shgcTables.left[orient][0][4], shgcTables.letf[orient][1][4]];
          // });
          //Final effective table
          orientations.forEach(orient => {
            result[orient] = [(baseResult[orient][0] * rightResult[orient][0]).toFixed(3), (baseResult[orient][1] * rightResult[orient][1]).toFixed(3)];
          });
        }
      }
      return result;
    },
    shadings: {
      get: function() {
        return this.$store.state.shadings;
      },
      set: function(newShadings) {
        this.$store.dispatch('setShadings', newShadings);
      },
    },
  },

  mounted() {
    // console.log('shadings', this.shadings);
  },

  methods: {
    saveShading() {
      //Save edited shading
      if (this.shading) {
        let existIndex = this.shadings.findIndex(item => item.id === this.shading.id);
        console.log('exist index', existIndex);
        if (existIndex !== -1) {
          this.shadings[existIndex] = {
            id: this.shading.id,
            type: this.selectedtype,
            title: this.title,

            // title: this.selectedtype + '-' + `${this.overhangH}(H)` + '-' + `${this.overhangV}(V)`,
            overhangV: this.overhangV,
            overhangH: this.overhangH,
            overhangLeftV: this.overhangLeftV,
            overhangLeftH: this.overhangLeftH,
            overhangRightV: this.overhangRightV,
            overhangRightH: this.overhangRightH,
            overhangPF: this.overhangPF,
            shgcEquiv: this.shgcEquiv,
          };
          console.log('Existing shading saved', this.shadings[existIndex]);
        }
      } else {
        //New Shading save in store.
        this.shadings.push({
          id: uid().substring(0, 4), //
          type: this.selectedtype,
          title: this.title,
          // title: this.selectedtype + '-' + `${this.overhangH}(H)` + '-' + `${this.overhangV}(V)`,
          overhangV: this.overhangV,
          overhangH: this.overhangH,
          overhangLeftV: this.overhangLeftV,
          overhangLeftH: this.overhangLeftH,
          overhangRightV: this.overhangRightV,
          overhangRightH: this.overhangRightH,
          overhangPF: this.overhangPF,
          shgcEquiv: this.shgcEquiv,
        });
        console.log('New Shading saved !!');
      }

      // save shadings in localstorage.
      localStorage.setItem('shadings', JSON.stringify(this.shadings));
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.shgc-dialog-btn {
  display: flex;
  justify-content: flex-end;
}
</style>
